import { Stage } from '@eventbrite/webapp-constants';

/**
 * Gets the stableId from cookies.
 * This is used to pass the stableId to the checkout widget as a query parameter,
 * bypassing CloudFront's cookie filtering which strips the stableId cookie.
 */
export const getStableIdFromCookie = (): string | undefined => {
  if (typeof document === 'undefined') return undefined;
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, ...rest] = cookie.trim().split('=');
    if (name === 'stableId') {
      return rest.join('=');
    }
  }
  return undefined;
};

export const getEBWidgetsScriptUrl = (stage: Stage, serverUrl: string): string => {
  const EB_WIDGETS_SCRIPT_URL: Record<string, string> = {
    [Stage.LOCAL]: `https://www.evbqa.com/static/widgets/eb_widgets.js`,
    [Stage.TEST]: `${serverUrl}/static/widgets/eb_widgets.js`,
    [Stage.PROD]: `${serverUrl}/static/widgets/eb_widgets.js`,
  };
  return EB_WIDGETS_SCRIPT_URL[stage] || EB_WIDGETS_SCRIPT_URL[Stage.TEST];
};
